export default "__VITE_ASSET__T15yqjDj__"